"use client";

import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function ReadyToStartYourJourney() {
  const [scrollY, setScrollY] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="235468" id="prêt-pour-lévolution" className="bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden py-24 md:py-32">
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes glitch {
          0% { clip-path: inset(20% 0 30% 0); transform: translate(-5px, 5px); }
          20% { clip-path: inset(60% 0 10% 0); transform: translate(5px, -5px); }
          40% { clip-path: inset(40% 0 50% 0); transform: translate(-5px, 0); }
          60% { clip-path: inset(80% 0 5% 0); transform: translate(5px, 5px); }
          80% { clip-path: inset(10% 0 70% 0); transform: translate(-5px, -5px); }
          100% { clip-path: inset(30% 0 20% 0); transform: translate(0); }
        }
        .glitch-hover:hover {
          animation: glitch 0.3s infinite linear alternate-reverse;
        }
      `
    }} />

      {}
      <div className="absolute -inset-[50%] -z-20 opacity-100" style={{
      backgroundImage: "linear-gradient(135deg, #050505 0%, #0a0a0a 100%)",
      transform: `translateY(${scrollY * 0.1}px)`,
      transition: "transform 0.1s ease-out"
    }} />

      {}
      <div className="absolute inset-0 -z-10 mix-blend-overlay opacity-[0.05] pointer-events-none" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} />

      <div className="container relative z-10 mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-16 lg:gap-24">
          
          {}
          <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-12 opacity-0"}`}>
            <h2 className="font-serif mb-6 text-6xl font-bold leading-none tracking-tighter text-white md:text-8xl lg:text-9xl">
              Prêt pour <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-secondary to-primary drop-shadow-[0_0_15px_rgba(0,240,255,0.4)]">
                l'évolution ?
              </span>
            </h2>
            
            <p className="mb-10 max-w-xl text-lg font-medium text-slate-400 md:text-2xl leading-relaxed">
              Propulsez votre présence digitale vers de nouveaux sommets avec l'expertise de <span className="text-primary">Smilegeeks</span>. L'innovation n'attend pas.
            </p>

            <div className="flex flex-col sm:flex-row items-start gap-6">
              <Button asChild size="lg" className="h-auto rounded-lg bg-primary/10 border border-primary/50 px-10 py-6 text-lg font-bold text-primary transition-all duration-300 hover:scale-105 hover:bg-primary hover:text-primary-foreground hover:shadow-[0_0_40px_rgba(0,240,255,0.5)] md:text-xl">
                <Link to="/ContactPage">
                  Initier le Contact <ArrowRight className="ml-2 size-6" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative flex justify-center items-center">
            <div className="relative w-full max-w-lg aspect-square transition-transform duration-100 ease-out" style={{
            transform: `translateY(${scrollY * -0.05}px)`,
            animation: "float 6s ease-in-out infinite"
          }}>
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-secondary/20 blur-3xl rounded-lg -z-10" />
              
              {}
              <div className="relative p-1 rounded-lg bg-gradient-to-tr from-primary via-secondary to-primary overflow-hidden group">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/digital_evolution_core.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/digital_evolution_core.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646506/img/digital_evolution_core.png-wvc-sizes" alt="Digital technology and AI visualization" className="w-full h-full object-cover rounded-lg grayscale group-hover:grayscale-0 transition-all duration-700 glitch-hover" loading="lazy" />
                
                {}
                <div className="absolute top-4 right-4 font-mono text-[10px] text-primary/70 tracking-widest uppercase bg-black/60 backdrop-blur-md px-2 py-1 rounded-md border border-primary/20">
                  System_Active: 100%
                </div>
                <div className="absolute bottom-4 left-4 font-mono text-[10px] text-secondary/70 tracking-widest uppercase bg-black/60 backdrop-blur-md px-2 py-1 rounded-md border border-secondary/20">
                  Innovation_Protocol.v2
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}